import { compose, withProps, branch } from 'recompose';

import Calendar from './Calendar';
import formControl from '../formControl';
import withHolidays from './withHolidays';

const DatesInput = withHolidays(Calendar);

export { DatesInput };
export default compose(
  withProps({
    isLabel: false,
  }),
  formControl,
  branch(
    ({ singleDay }) => singleDay,
    withProps({
      hideRepeat: true,
      hideClear: true,
      hideInput: true,
      hideToggleSelectWeekDays: true,
    }),
  ),
)(DatesInput);
